import React from 'react';

import { DataGridProps, TabObj, ThemedTabs, ThemedTabsProps } from '@fides/fides-react-components';
import { AwDataGridProps } from './AwDataGrid';
import { useDatasource } from './useDataSource';

type AwThemedTabsProps = ThemedTabsProps;

const addDataSourceToGridProperties: (gridProperties: AwDataGridProps) => DataGridProps = (gridProperties) => {
  if (!gridProperties.url) {
    return gridProperties;
  }

  const {
    url,
    requestParams: params = {},
    serializer: paramsSerializer = {},
    columnMapping,
    errorHandler,
    columnDefs,
  } = gridProperties;

  const datasource = useDatasource({
      url,
      params,
      paramsSerializer,
    },
    params,
    columnMapping,
    errorHandler,
    columnDefs
  );

  return { ...gridProperties, datasource };
}

const addDatasourceToTab: (tab: TabObj) => TabObj = (tab) => {
  if (!tab.gridProperties) {
    return tab;
  }

  return { ...tab, gridProperties: addDataSourceToGridProperties(tab.gridProperties as AwDataGridProps) };
}

export const AwThemedTabs = (props: AwThemedTabsProps) => {
  const { tabs, ...rest } = props;

  return <ThemedTabs tabs={tabs.map(addDatasourceToTab)} {...rest} />
}
